import React, {Component} from 'react';
import {Button, Form, Icon} from "antd";
import * as Yup from 'yup';
import {Formik} from "formik";
import {PasswordInput} from "../Boilerplate/formikComponents";
import {compose} from "redux";
import {connect} from "react-redux";
import {updatePassword} from "../../actions/users";
import {withRouter} from "react-router";
import * as PropTypes from "prop-types";

class ResetPasswordButton extends Component {
    state = {
        loading: false
    };

    handleSubmit = () => {
        if (!Object.keys(this.props.values).length || Object.keys(this.props.errors).length) return;
        this.setState({ loading: true });
        this.props.onClick();
    };

    render() {
        return <Button type='primary' className='full-width' loading={this.state.loading}
                       onClick={this.handleSubmit}>{this.state.loading ? 'Updating your password...' : 'Submit'}</Button>;
    }
}

ResetPasswordButton.propTypes = { onClick: PropTypes.any };

class AccountRecovery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
    }
  }

  render() {
    const {
      onSubmit,
    } = this.props;
    return (
      <Formik
        initialValues={{}}
        onSubmit={(values, { setSubmitting }) => {
          const {password} = values;
          onSubmit && onSubmit(password);
        }}
        validationSchema={Yup.object().shape({
          password: Yup.string()
            .required('You must enter a password.')
            .min(8, 'Your password must be at least 8 characters.')
            .matches(/[a-z]/, 'Your password must have a lower-case letter in it.')
            .matches(/[A-Z]/, 'Your password must have an upper-case letter in it.')
            .matches(/[0-9]/, 'Your password must have a number in it.')
            .matches(/[^a-zA-Z0-9]/, 'Your password must have a special character in it.'),
        })}
      >
        {props => {
          const {
            // eslint-disable-next-line
            values, touched, errors, isSubmitting, handleChange, handleBlur, dirty,
            handleSubmit,
          } = props;
          return (
            <Form id='forgot-password' onSubmit={handleSubmit}>
                <h1>Reset your password</h1>
                <p>Enter a new password in the field below to change your password.</p>
                <PasswordInput
                    {...props}
                    placeholder='New Password'
                    key="password"
                    name="password"
                    inputProps={{ prefix: (<Icon type='lock'/>) }}
                />
                <Form.Item>
                    <ResetPasswordButton values={values} errors={errors} onClick={handleSubmit}/>
                </Form.Item>
            </Form>
          )
        }}
      </Formik>
    )
  }
}

export default compose(
  withRouter,
  connect(
    null,
    (dispatch, props) => ({
      onSubmit: (password) => dispatch(updatePassword(props.match.params.sid, password, props.history)),
    })
  )
)(AccountRecovery);



// WEBPACK FOOTER //
// ./src/components/Security/AccountRecovery.js